import React from 'react'

export function Button({children, href, variant = 'primary', size = 'md', full, className = '', onClick, type = 'button', target, rel}) {
  const classes = ['hlm-btn', `hlm-btn-${variant}`, size ? `hlm-btn-${size}` : '', full ? 'hlm-btn-full' : '', className]
    .filter(Boolean)
    .join(' ')

  if (href) {
    return (
      <a href={href} className={classes} onClick={onClick} target={target} rel={rel}>
        {children}
      </a>
    )
  }

  return (
    <button type={type} className={classes} onClick={onClick}>
      {children}
    </button>
  )
}
